import { useEffect } from 'react';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';

export default function ErikaDelaVegaPortfolio() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white text-gray-900 font-sans selection:bg-gray-200 selection:text-black">
      <title>Erika De La Vega | Estrategia de Contenido y Marca Personal | Mood Agency</title>
      <meta name="description" content="Descubre cómo Mood Agency potenció la marca personal de Erika De La Vega con estrategias de contenido, humor y gestión de redes sociales para conectar con una audiencia global." />
      <meta name="keywords" content="Erika De La Vega, marca personal, estrategia de contenido, marketing digital, redes sociales, branding, humor" />
      
      <Navbar />
      
      {/* Hero Section - Clean & Minimal like Home */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden bg-white">
        {/* Background Ripple Effect */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none overflow-hidden">
          <div className="absolute w-[60vw] h-[60vw] bg-[radial-gradient(circle,var(--tw-gradient-stops))] from-gray-200 via-gray-100/50 to-transparent rounded-full blur-[80px] opacity-100 z-0"></div>
          <div className="w-[90vw] h-[90vw] border border-gray-200 rounded-full absolute opacity-40"></div>
          <div className="w-[70vw] h-[70vw] border border-gray-300 rounded-full absolute opacity-50"></div>
          <div className="w-[50vw] h-[50vw] border border-gray-300 rounded-full absolute opacity-60"></div>
        </div>
        
        <div className="relative z-10 container mx-auto px-6 text-center">
          <div className="mb-8 animate-fade-in-up">
            <span className="font-display text-[10px] tracking-[0.4em] text-gray-400 uppercase">
              CASO DE ÉXITO 2014
            </span>
          </div>
          
          <h1 className="font-display text-[12vw] md:text-[8vw] leading-none font-bold uppercase tracking-tighter text-gray-900 mb-8 animate-fade-in-up delay-100">
            ERIKA DE LA VEGA
          </h1>
          
          <p className="max-w-2xl mx-auto font-sans text-xl text-gray-500 font-light leading-relaxed animate-fade-in-up delay-200">
            Estrategia de contenido y marca personal: Digitalizando el carisma para una audiencia global.
          </p>
        </div>
      </section>

      {/* Key Metrics - Minimalist Grid */}
      <section className="py-20 px-6 bg-white border-t border-gray-100">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12">
          <div className="text-center group">
            <div className="font-display text-6xl md:text-7xl font-bold text-gray-900 mb-2 group-hover:scale-105 transition-transform duration-500">7.5M+</div>
            <p className="font-sans text-sm text-gray-400 uppercase tracking-widest">Likes Recibidos</p>
          </div>
          <div className="text-center group">
            <div className="font-display text-6xl md:text-7xl font-bold text-gray-900 mb-2 group-hover:scale-105 transition-transform duration-500">415K</div>
            <p className="font-sans text-sm text-gray-400 uppercase tracking-widest">Seguidores Instagram</p>
          </div>
          <div className="text-center group">
            <div className="font-display text-6xl md:text-7xl font-bold text-gray-900 mb-2 group-hover:scale-105 transition-transform duration-500">253K</div>
            <p className="font-sans text-sm text-gray-400 uppercase tracking-widest">Seguidores Twitter</p>
          </div>
        </div>
      </section>

      {/* The Context - Clean Typography */}
      <section className="py-32 px-6 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-gray-900 mb-12 uppercase">El Contexto</h2>
          <p className="font-sans text-xl md:text-2xl text-gray-500 leading-relaxed font-light">
            Erika De la Vega es una figura icónica en los medios latinoamericanos. Sin embargo, su innegable talento y carisma no se estaban traduciendo efectivamente al mundo digital. Necesitaba reflejar su marca personal en redes sociales para conectar auténticamente con una audiencia internacional.
          </p>
        </div>
      </section>

      {/* Visual Break - Full Width Image */}
      <section className="w-full h-[80vh] overflow-hidden">
        <img 
          src="/assets/images/portfolio/erika/header.png" 
          alt="Erika De La Vega Brand Strategy" 
          className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-1000 ease-out"
        />
      </section>

      {/* The Challenge - Minimal List */}
      <section className="py-32 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-20 items-center">
          <div>
            <h2 className="font-display text-4xl md:text-5xl font-bold text-gray-900 mb-8 uppercase leading-tight">
              Digitalizar el<br/>Carisma
            </h2>
            <p className="font-sans text-lg text-gray-500 leading-relaxed mb-12">
              El reto era claro: trasladar el humor, la inteligencia y la personalidad única de Erika de la pantalla de TV a las pantallas de los móviles, sin perder su esencia.
            </p>
          </div>
          <div className="space-y-12">
            <div className="border-l border-gray-300 pl-8">
              <h3 className="font-display text-xl font-bold text-gray-900 mb-2 uppercase">Identidad Digital</h3>
              <p className="font-sans text-gray-500">Definir una voz y tono en redes que se sintiera auténtico y cercano, no corporativo.</p>
            </div>
            <div className="border-l border-gray-300 pl-8">
              <h3 className="font-display text-xl font-bold text-gray-900 mb-2 uppercase">Engagement</h3>
              <p className="font-sans text-gray-500">Transformar seguidores pasivos en una comunidad activa que interactúa y comparte.</p>
            </div>
            <div className="border-l border-gray-300 pl-8">
              <h3 className="font-display text-xl font-bold text-gray-900 mb-2 uppercase">Viralidad</h3>
              <p className="font-sans text-gray-500">Crear contenido "shareable" que trascendiera las fronteras de su audiencia tradicional.</p>
            </div>
          </div>
        </div>
      </section>

      {/* The Solution - Grid Layout */}
      <section className="py-32 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="mb-20">
            <h2 className="font-display text-4xl md:text-5xl font-bold text-gray-900 uppercase">La Solución</h2>
          </div>

          <div className="grid md:grid-cols-3 gap-px bg-gray-200 border border-gray-200">
            <div className="bg-white p-12 hover:bg-gray-50 transition-colors duration-300">
              <h3 className="font-display text-2xl font-bold text-gray-900 mb-6 uppercase">Humor Estratégico</h3>
              <p className="font-sans text-gray-500 leading-relaxed">
                Desarrollamos una estrategia centrada en sus valores más fuertes: personalidad y humor. Logramos que los usuarios la reconocieran como una mujer divertida y familiar con la que podían identificarse día a día.
              </p>
            </div>
            <div className="bg-white p-12 hover:bg-gray-50 transition-colors duration-300">
              <h3 className="font-display text-2xl font-bold text-gray-900 mb-6 uppercase">Newsjacking</h3>
              <p className="font-sans text-gray-500 leading-relaxed">
                Diseñamos piezas de contenido ágil ("Newsjacking") reaccionando a hechos relevantes de la farándula y actualidad con montajes divertidos que encajaban con su personalidad sarcástica.
              </p>
            </div>
            <div className="bg-white p-12 hover:bg-gray-50 transition-colors duration-300">
              <h3 className="font-display text-2xl font-bold text-gray-900 mb-6 uppercase">Insights Femeninos</h3>
              <p className="font-sans text-gray-500 leading-relaxed">
                Conectamos con la audiencia femenina a través de insights de la vida cotidiana (el caos del lunes, la dieta, la maternidad), generando una identificación inmediata y alto engagement.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Impact - Minimal Text */}
      <section className="py-32 px-6 bg-black text-white">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="font-display text-3xl md:text-4xl font-bold mb-20 uppercase tracking-widest">Impacto Global</h2>
          
          <div className="max-w-4xl mx-auto">
            <p className="font-display text-2xl md:text-4xl leading-tight mb-12">
              "Erika desarrolló una marca personal sólida que destaca por su carisma y autenticidad. Hoy se posiciona con fuerza en mercados clave como Estados Unidos, México, Canadá y Panamá."
            </p>
            <div className="w-20 h-1 bg-white mx-auto opacity-30"></div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
